<template>
  <div class="divider" style="position: relative;">
    <div id="pdfDom" ref="pdf" class="export" style="width: 1920px;position: absolute;left: 0;top: 0">
      <div class="word">
        <div class="home">
          <div class="word-name">
            {{ cepingren.company }}
          </div>
          <div class="com-x">
            诊断行业：<span class="com-span1">{{ cepingren.category_name }}</span><br>
            资讯供应者姓名：<span class="com-span1">{{ cepingren.user_name }}</span><br>
            职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：<span class="com-span2">{{ cepingren.job }}</span><br>
            诊断ID：<span class="com-span2">AI 10{{ cepingren.id }}</span><br>
          </div>
          <div class="time">
            诊断日期：{{ timeaa }}
          </div>
<!--          <div class="time">-->
<!--            诊断日期：2023年02月04日-->
<!--          </div>-->
          <div class="preface-footer">报告由北清智中企业管理咨询有限公司技术咨询团队独家研发
          </div>
        </div>
        <div class="preface">
          <div class="predace-text">
            <div class="text-l">{{ cepingren.company }}</div>
            <div class="text-r">《S-AI诊断赋能报告》</div>
          </div>
          <div class="preface-des">
            <div class="pre-div"><h1>前言</h1></div>
            <p>
              企业存在很多问题都“无法”发现，即使发现了，也认为那是常态，这是当今很多企业存在的一个普遍现象！企业存在的普遍问题，有的在领导者看起来司空见惯，有的让领导心急如焚，有的问题爆发也不会影响运作，有的问题爆发对企业是致命性的。
            </p>
            <p>
              作为领导的您，一定会遇到一些自己都无法发现和不在意的企业经营管理问题吧。我们如何将日常习惯性的问题和突发性的问题，减少或消除到可以接收的范围之内呢？这是我们现今企业老板或领导者必须要面对和解决的企业经营管理问题。
            </p>
            <p>
              数据化时代的来临，国家新治理模式就是数据化治理时代的开端，国家治理从银行、快递、财税管理、疫情防控、网络治理等，到生活消费及出行如平台购物、APP、抖音、京东、淘宝、天猫、拼多多、智能车库、滴滴出行、无人驾驶飞机等，再到企业的生产制造管理软件如设备管控、仓储物料查询、供应链数据化等。显而易见的是，我们的生活、工作、出行无处不在用数据化管理。
            </p>
            <p>
              我们的企业在寻求解决存在的一系列问题时，还在耗用着大量的人工做企业管理调研分析。尽管企业管理调研分析属于知识技术性的活动，需要靠经验和现场感受来获得问题现象，从而感知到问题的起源，并针对问题进行分析和提出不同的解决方案，正如企业老板外请咨询公司调研，但是却产生所提问题反馈的现象和企业实际情况不一样，甚至存在较大差距的现象！究其原因有三：一是调研员水平不够；二是面对面真实的问题不好直面回答；三是没有系统性的调研流程和内容。为深入探究及解决以上问题，我们组织了不同行业顶级专家和资深的咨询师，进行全方位的剖析及反复的验证，十年磨一剑，编写了《S-AI全方位诊断组织发展系统》软件，以期综合性的解决企业经营管理问题。
            </p>
            <p>
              在这里，针对此诊断赋能报告理解与阅读，具体思路方向和启示如下：
            </p>
            <p>
              一、组织全方位测评项目共计二十项，包含：战略管理、营销管理、技术能力、人力资源、物流供需、人才机制、品质管理、品牌认知、作业标准、目标管理、计划管控、知识运用、现场氛围、资源运用、成本管理、数据运用、监督反腐、企业文化、危机管理、创新突破。
            </p>
            <p>
              二、报告采用管理规范实用规则：人才、制度、流程、方法、工具来进询问和问题分析而成。
            </p>
            <p>
              三、报告分析中的一些语言采用平常交流平铺式的方式来进行解说，在评价企业的方式采用的是事件产生后三个铁律原则：好、一般、差（这是东方与西方的不同解答）。
            </p>
            <p>
              四、报告诊断改进的提示是根据现有的状况，结合咨询专家的咨询经验和组织未来发展进行解答，值得组织借鉴。
            </p>
            <p>
              五、所有的知识问答都来自于本次组织负责人的精心思考和对组织存在的问题点解答，包括组织隐晦的或组织不愿意暴露的问题。
            </p>
            <p>
              六、所有问题的延展性，除企业负责人外其它的人员均不知晓，如企业要咨询老师咨询项目外，均禁止外传。
            </p>
            <p>
              欢迎使用本专家团队精心为您开发的企业测评软件，如有问题可联系本公司！
            </p>
          </div>
          <div class="preface-footer">报告由北清智中咨询团队独家（研发）诊断提供<div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">1</div>
          </div>
        </div>
      </div>
      <div class="word-3">
        <div class="predace-text">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div class="word-3-title">
          <div class="word-3-title-name"><h1>全项目实况统计表</h1></div>
          <div class="word-3-title">
            <div class="word-3-des">
              <div class="word-3-l">
                序号
              </div>
              <div style="width: 100%;height: 100%;">
                <div style="text-align: center;line-height: 90px;border-bottom: 1px solid #000;height: 50%;">分数状况
                </div>
                <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;height: 50%;">
                  <div
                    style="text-align: center;border-right: 1px solid #000;height: 100%;line-height: 90px;">
                    项目名称
                  </div>
                  <div
                    style="text-align: center;border-right: 1px solid #000;height: 100%;line-height: 90px;">
                    人才
                  </div>
                  <div
                    style="text-align: center;border-right: 1px solid #000;height: 100%;line-height: 90px;">
                    制度
                  </div>
                  <div
                    style="text-align: center;border-right: 1px solid #000;height: 100%;line-height: 90px;">
                    流程
                  </div>
                  <div
                    style="text-align: center;border-right: 1px solid #000;height: 100%;line-height: 90px;">
                    方法
                  </div>
                  <div style="text-align: center;height: 100%;line-height: 90px;">工具</div>
                </div>
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 180px;border-left: 1px solid #000;">
                单项合计
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="width: 100%;border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                1
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  战略管理
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[0]" :key="index">{{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie0 }}
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="width: 100%;border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                2
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  营销管理
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[1]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie1 }}
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns:1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="width: 100%;border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                3
              </div>
              <div style="display: grid;grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  技术能力
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[2]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie2 }}
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                4
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  人力资源
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[3]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie3 }}
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                5
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  物流供需
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[4]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="width: 100%;height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie4 }}
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                6
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  人才机制
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[6]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie6 }}
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                7
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  品质管理
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[6]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height:90px;">
                {{ zhanlie6 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                8
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  品牌认知
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[7]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie7 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height:90px;">
                9
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  作业标准
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[8]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie8 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                10
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  目标管理
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[9]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie9 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                11
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  计划管控
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[10]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie10 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                12
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  知识运用
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[11]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie11 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                13
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  现场氛围
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[12]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie12 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                14
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  资源运用
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[13]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie13 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                15
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  成本管理
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[14]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie14 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                16
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  数据运用
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[15]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie15 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                17
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  监督反腐
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[16]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie16 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                18
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  企业文化
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[17]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie17 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                19
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  危机管理
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[18]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie18 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                20
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  创新突破
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"
                     v-for="(item,index) in fenarr[19]" :key="index">
                  {{ item }}
                </div>
              </div>
              <div style="height: 100%;text-align: center;line-height: 90px;">
                {{ zhanlie19 }}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 5fr 1fr;border: 1px solid #000;height: 90px;">
              <div style="border-right: 1px solid #000;width: 100%;height: 100%;text-align: center;line-height: 90px;">
                合计总分
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;">
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;"></div>
                <div style="border-right: 1px solid #000;;height: 100%;text-align: center;line-height: 90px;">
                  {{ rencaifenshu }}
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  {{ zhidufenshu }}
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  {{ liuchengfenshu }}
                </div>
                <div style="border-right: 1px solid #000;;height: 100%;text-align: center;line-height: 90px;">
                  {{ fangfafenshu }}
                </div>
                <div style="border-right: 1px solid #000;height: 100%;text-align: center;line-height: 90px;">
                  {{ gongjufenshu }}
                </div>
              </div>
              <div
                style="height: 100%;text-align: center;line-height: 90px;">
                {{ aaaa }}
              </div>
            </div>
          </div>
          <div style="font-size: 22px;margin-top: 10px;">备注： 诊断项目总分为 100
            分，在组织本阶段：良好90分以上，健康80～89分；亚健康70～79分，70分以下为不健康
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;position: absolute;bottom: 120px;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">2</div>
        </div>
      </div>
      <div class="chart pobg"
           style="height: 690mm;width: calc(1920px - 240px);display: flex;flex-direction: column;align-items: center;padding:120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;">
          <h1>
            全项目实况分析趋势图
          </h1>
          <div id="main" style="width: calc(100% - 50px);height: 1500px;padding: 20px;border: 5px solid #000;"></div>
          <div class="shuoming" style="text-align: start;width: 100%;font-size: 36px;margin-top: 10px;">
            说明：本次组织诊断数据分析（组织健康判断标准：良好：0.85-1.0；健康：0.65-0.80；亚健康：0.45-0.60;
            不健康：0.25-0.40；危机：0.1-0.2）；
          </div>
          <div class="tongji" style="text-align: start;width: 100%;font-size: 36px;margin-top: 10px;line-height: 40px;">
            人才：良好项次：{{ rencai.良好 }}；健康项次：{{ rencai.健康 }}；亚健康项次：{{
              rencai.亚健康
            }}；不健康项次：{{ rencai.不健康 }}；危机项次：{{ rencai.危机 }}。<br>
            制度：良好项次：{{ zhidu.良好 }}；健康项次：{{ zhidu.健康 }}；亚健康项次：{{
              zhidu.亚健康
            }}；不健康项次：{{ zhidu.不健康 }}；危机项次：{{ zhidu.危机 }}。<br>
            流程：良好项次：{{ liucheng.良好 }}；健康项次：{{ liucheng.健康 }}；亚健康项次：{{
              liucheng.亚健康
            }}；不健康项次：{{ liucheng.不健康 }}；危机项次：{{ liucheng.危机 }}。<br>
            方法：良好项次：{{ fangfa.良好 }}；健康项次：{{ fangfa.健康 }}；亚健康项次：{{
              fangfa.亚健康
            }}；不健康项次：{{ fangfa.不健康 }}；危机项次：{{ fangfa.危机 }}。<br>
            工具：良好项次：{{ gongju.良好 }}；健康项次：{{ gongju.健康 }}；亚健康项次：{{
              gongju.亚健康
            }}；不健康项次：{{ gongju.不健康 }}；危机项次：{{ gongju.危机 }}。
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;position: absolute;bottom: 120px;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">3</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;">
          <div style="text-align: center;margin-bottom: 20px"><h1 style="margin-bottom: 30px">全项目赋能分析</h1></div>
          <div style="margin-bottom: 10px;font-size: 18px;">
            经过公司的核心人员对二十项目和五维度的反馈以及组织过去对现在产生的影响及组织改变现状的方式如下：
          </div>
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr;height: 90px;border: 1px solid #000;">

              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">项目</div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">维度</div>
              <div style="display: grid;grid-template-columns: 7fr 7fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(0,10)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:7fr 7fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">4</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 60px">
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div style="display: grid;grid-template-columns: 3fr 3fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(10,20)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:3fr 3fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">5</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 689.5mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 60px">
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div style="display: grid;grid-template-columns: 3fr 3fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(20,30)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:3fr 3fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">6</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 60px">
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div style="display: grid;grid-template-columns: 3fr 3fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(30,40)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:3fr 3fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">7</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 689.5mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 60px">
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div style="display: grid;grid-template-columns: 3fr 3fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(40,50)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:3fr 3fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">8</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 60px">
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div style="display: grid;grid-template-columns: 3fr 3fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(50,60)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:3fr 3fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">9</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 60px">
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div style="display: grid;grid-template-columns: 3fr 3fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(60,70)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:3fr 3fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">10</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 60px">
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div style="display: grid;grid-template-columns: 3fr 3fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(70,80)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:3fr 3fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">11</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 60px">
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div style="display: grid;grid-template-columns: 3fr 3fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(80,90)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:3fr 3fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">12</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width: calc(1920px - 240px);;display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 60px">
          <div style="width: 100%;font-size: 36px;">
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                项目维度解答
              </div>
            </div>
            <div
              style="display: grid;grid-template-columns: 1fr 1fr 8fr;height: 90px;border: 1px solid #000;">
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div
                style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;"></div>
              <div style="display: grid;grid-template-columns: 3fr 3fr 1fr;">
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度目前在组织的产生效果
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  企业项目维度情况评价
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;">分数</div>
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(90,100)" :key="index" class="biao1">
              <div style="display: grid;grid-template-columns:1fr 1fr 8fr;min-height: 160px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;border-right: 1px solid #000;line-height:160px">
                  {{ item.cp_titles_name }}
                </div>
                <div v-for="(list,i) in item.question_data.select_effect_data" :key="i"
                     style="display: grid;grid-template-columns:3fr 3fr 1fr;height: 100%;">
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ list.effect }}
                  </div>
                  <div style="width: 100%;height: 100%;border-right: 1px solid #000;display: flex;align-items: center;">
                    {{ item.question_data.evaluate }}
                  </div>
                  <div style="width: 100%;height: 100%;line-height:160px">
                    {{ list.select_score }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">13</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width:calc(1920px - 240px);display: flex;flex-direction: column;align-items: center;padding:120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;">
          <div style="text-align: center;margin-bottom: 60px"><h1>组织发展赋能改进</h1></div>
          <div>
            <div
              style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;height: 90px;border: 1px solid #000;font-size: 36px">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                健康状况
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                建议组织解决途径
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(0,22)" :key="index" class="biao2" style="font-size: 36px">
              <div
                style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;min-height: 90px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_titles_name }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;"
                     v-if="item.question_data.status != ''">
                  {{ item.question_data.status }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;" v-else>
                  良好
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;"
                     v-if="item.question_data.solutions != ''">
                  {{ item.question_data.solutions }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;" v-else>
                  继续保持
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer"
             style="font-size: 36px;color: #808080;margin-top: 740px;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">14</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width:calc(1920px - 240px);display: flex;flex-direction: column;align-items: center;padding:120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 20px">
          <div>
            <div
              style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;height: 90px;border: 1px solid #000;font-size: 36px">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                健康状况
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                建议组织解决途径
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(22,46)" :key="index" class="biao2" style="font-size: 36px">
              <div
                style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;min-height: 90px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_titles_name }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;"
                     v-if="item.question_data.status != ''">
                  {{ item.question_data.status }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;" v-else>
                  良好
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;"
                     v-if="item.question_data.solutions != ''">
                  {{ item.question_data.solutions }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;" v-else>
                  继续保持
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer"
             style="font-size: 36px;color: #808080;margin-top: 740px;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">15</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width:calc(1920px - 240px);display: flex;flex-direction: column;align-items: center;padding:120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 20px">
          <div>
            <div
              style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;height: 90px;border: 1px solid #000;font-size: 36px">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                健康状况
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                建议组织解决途径
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(46,70)" :key="index" class="biao2" style="font-size: 36px">
              <div
                style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;min-height: 90px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_titles_name }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;"
                     v-if="item.question_data.status != ''">
                  {{ item.question_data.status }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;" v-else>
                  良好
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;"
                     v-if="item.question_data.solutions != ''">
                  {{ item.question_data.solutions }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;" v-else>
                  继续保持
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer"
             style="font-size: 36px;color: #808080;margin-top: 740px;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">16</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 690mm;width:calc(1920px - 240px);display: flex;flex-direction: column;align-items: center;padding:120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 20px">
          <div>
            <div
              style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;height: 90px;border: 1px solid #000;font-size: 36px">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                健康状况
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                建议组织解决途径
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(70,94)" :key="index" class="biao2" style="font-size: 36px">
              <div
                style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;min-height: 90px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_titles_name }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;"
                     v-if="item.question_data.status != ''">
                  {{ item.question_data.status }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;" v-else>
                  良好
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;"
                     v-if="item.question_data.solutions != ''">
                  {{ item.question_data.solutions }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;" v-else>
                  继续保持
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer"
             style="font-size: 36px;color: #808080;margin-top: 740px;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">17</div>
        </div>
      </div>
      <div class="pobgs"
           style="height: 689.5mm;width:calc(1920px - 240px);display: flex;flex-direction: column;align-items: center;padding:120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;margin-top: 20px">
          <div>
            <div
              style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;height: 90px;border: 1px solid #000;font-size: 36px">
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                项目
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                维度
              </div>
              <div style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                健康状况
              </div>
              <div
                style="width: 100%;height: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;text-align: center;">
                建议组织解决途径
              </div>
            </div>
            <div v-for="(item,index) in test_results.slice(94,100)" :key="index" class="biao2" style="font-size: 36px">
              <div
                style="display: grid;grid-template-columns: 1fr 0.5fr 1.5fr 5fr;min-height: 90px;border: 1px solid #000;">
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_classify_name }}
                </div>
                <div
                  style="width: 100%;text-align: center;height: 100%;line-height: 90px;border-right: 1px solid #000;">
                  {{ item.cp_titles_name }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;"
                     v-if="item.question_data.status != ''">
                  {{ item.question_data.status }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-right: 1px solid #000;" v-else>
                  良好
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;"
                     v-if="item.question_data.solutions != ''">
                  {{ item.question_data.solutions }}
                </div>
                <div style="width: 100%;height: 100%;line-height: 90px;border-left: 1px solid #000;" v-else>
                  继续保持
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preface-footer"
             style="font-size: 36px;color: #808080;margin-top: 740px;bottom: 120px;position: absolute;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">18</div>
        </div>
      </div>
      <div class="pobg"
           style="height: 700mm;width:calc(1920px - 240px);display: flex;flex-direction: column;align-items: center;padding: 120px 120px 0 120px;position: relative;">
        <div class="predace-text"
             style="display: flex;font-size: 36px;color: #808080;">
          <div class="text-l">{{ cepingren.company }}</div>
          <div class="text-r">《S-AI诊断赋能报告》</div>
        </div>
        <div style="width: 100%;">
          <div style="text-align: center;margin-bottom: 60px"><h1>结 论</h1></div>
          <div>
            <p>诊断的内容经公司<span
              style="border-bottom: 1px solid #000;display: initial;height: 20px;padding:0 10px;text-indent: 0em;">{{
                cepingren.job
              }}</span>（职位）<span
              style="text-indent: 0em;border-bottom: 1px solid #000;display: initial;height: 20px;padding:0 10px;">{{
                cepingren.user_name
              }}</span>（姓名），全面的将组织现有情况，有代表性的给予回复，其回复的内容符合组织过去和现有的状况，信息真实可靠。从本次组织诊断项目来看，我们可以了解到组织在二十大项目（战略管管理、营销管理……数据运用、监督反腐、企业文化、危机管理、突破创新）、五维企业管理标准（人才、制度、流程、方法、工具）方面，具备实用性、经济性、符合性、全局性、人性化、组合性等管理特征，了解到组织目前经营管理的健康水准。
            </p>
            <div v-html="baogs"></div>
            <p>
              非常感谢<span
              style="text-indent: 0em;border-bottom: 1px solid #000;display: initial;height: 20px;padding:0 10px;">{{
                cepingren.company
              }}</span>选择北清智中咨询团队为您组织做S-AI全方位精准诊断，希望能为组织健康发展保驾护航！共同打造卓越盈利的组织系统！
            </p>
          </div>
        </div>
        <div class="preface-footer" style="font-size: 36px;color: #808080;position: absolute;bottom: 120px;">
          报告由北清智中咨询团队独家（研发）诊断提供
          <div style="position: absolute;top: 50%;transform: translateY(-50%);right: -540px;font-size:36px;">19</div>
        </div>
      </div>
      <div style="height: 720mm;width:1920px;">
        <img src="../../../static/image/zui.png" alt="" style="width: 100%;height: 100%;object-fit: cover">
      </div>
    </div>
    <div class="dow">
      <button class="dow-btn" @click="downloadFile()">点击下载报告</button>
    </div>
<!--    <div class="dows">-->
<!--      <button class="dow-btn" @click="getPdfs()">点击保存报告</button>-->
<!--    </div>-->
    <div class="bgssss">
      <div class="te">请复制链接到电脑端浏览器查看并下载保存</div>

    </div>
    <el-dialog title="正在下载，请等待" v-show="progressShow" :close-on-click-modal="false" :close-on-press-escape="false"
               :show-close="false" width="20%">
      <div style="text-align: center;">
        <el-progress :percentage="percentage" type="circle"></el-progress>
      </div>
    </el-dialog>
  </div>

</template>
<script>
import * as echarts from "echarts";
var indexurl = localStorage.getItem('url')

let loading
export default {
  // metaInfo() {
  //   return {
  //     meta: this.metaData
  //   }
  // },
  data() {
    return {
      // metaData: [{
      //   name: 'viewport',
      //   content: 'width=device-width, user-scalable=no, initial-scale=0.3, maximum-scale=0.2, minimum-scale=0.2'
      // }],
      htmlTitle:'诊断报告',
      percentage: 0, //进度条的占比
      progressShow: false, // 是否显示进度条弹出层
      namessss: "诊断报告",
      rencai: {},
      zhidu: {},
      liucheng: {},
      fangfa: {},
      gongju: {},
      aaaa: '',
      myChart: {},
      urlCode: '',
      timeaa: '',
      option: {
        title: {},
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          right: 0,
          orient: 'wertical',
          itemGap: 40,
          top: 'middle',
          borderWidth: 4,
          padding: [10, 10],
          itemHeight: 12,
          width: "10%",
          itemWidth: 5,
          textStyle: {
            fontWeight: 'bold',
            fontSize: 26
          },
          data: ['战略管理', '营销管理', '技术能力', '人力资源', '物流供需', '人才机制', '品质管理', '品牌认知', '作业标准', '目标管理', '计划管控', '知识运用', '现场氛围', '资源运用', '成本管理', '数据运用', '监督反腐', '企业文化', '危机管理', '创新突破']
        },
        grid: {
          show: true,
          left: '3%',
          right: '15%',
          bottom: '3%',
          top: '5%',
          containLabel: true,
        },
        xAxis: {
          nameTextStyle: {
            fontSize: 30,
            fontWeight: 'bold',
          },
          type: 'category',
          data: ['人才', '制度', '流程', '方法', '工具']
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 1,
          interval: 0.05,

          nameTextStyle: {
            fontSize: 30,
            fontWeight: 'bold',
          }
        },
        series: [
          {
            name: '战略管理',
            type: 'line',
            data: []
          },
          {
            name: '营销管理',
            type: 'line',
            data: []
          },
          {
            name: '技术能力',
            type: 'line',
            data: []
          },
          {
            name: '人力资源',
            type: 'line',
            data: []
          },
          {
            name: '物流供需',
            type: 'line',
            data: []
          },
          {
            name: '人才机制',
            type: 'line',
            data: []
          },
          {
            name: '品质管理',
            type: 'line',
            data: []
          },
          {
            name: '品牌认知',
            type: 'line',
            data: []
          },
          {
            name: '作业标准',
            type: 'line',
            data: []
          },
          {
            name: '目标管理',
            type: 'line',
            data: []
          },
          {
            name: '计划管控',
            type: 'line',
            data: []
          },
          {
            name: '知识运用',
            type: 'line',
            data: []
          },
          {
            name: '现场氛围',
            type: 'line',
            data: []
          },
          {
            name: '资源运用',
            type: 'line',
            data: []
          },
          {
            name: '成本管理',
            type: 'line',
            data: []
          },
          {
            name: '数据运用',
            type: 'line',
            data: []
          },
          {
            name: '监督反腐',
            type: 'line',
            data: []
          },
          {
            name: '企业文化',
            type: 'line',
            data: []
          },
          {
            name: '危机管理',
            type: 'line',
            data: []
          },
          {
            name: '创新突破',
            type: 'line',
            data: []
          }
        ]

      },
      zhongji: [],
      fenarr: [],
      fileUrl: '',
      zhanlie0: "",
      zhanlie1: "",
      zhanlie2: "",
      zhanlie3: "",
      zhanlie4: "",
      zhanlie5: "",
      zhanlie6: "",
      zhanlie7: "",
      zhanlie8: "",
      zhanlie9: "",
      zhanlie10: "",
      zhanlie11: "",
      zhanlie12: "",
      zhanlie13: "",
      zhanlie14: "",
      zhanlie15: "",
      zhanlie16: "",
      zhanlie17: "",
      zhanlie18: "",
      zhanlie19: "",
      test_results: [],
      cepingren: [],
      dow: '',
      baogs: '',
      opst: false,
      rencaifenshu: '',
      zhidufenshu: '',
      liuchengfenshu: '',
      fangfafenshu: '',
      gongjufenshu: '',

    }
  },
  created() {
    this.getURL()
    this.getNowDate()
    this.pingxe()
    this.an()
    this.baog()


  },
  methods: {
    handleExport(){
      downloadPDF(this.$refs.pdf)
    },
    getURL() {
      let url = window.location.href
      this.urlCode = url.substring(url.indexOf("=") + 1)
      console.log(this.urlCode,'this.urlCode')
    },
    pingxe() {
      let url = window.location.href
      let urlCode = url.substring(url.indexOf("=") + 1)
      console.log(urlCode,'this.urlCode')
      let that = this
      this.$axios({
        method: "get",
        url: indexurl + "/index.php/api/index/getVisitorInfo?key=" + urlCode,
        data: {}
      }).then(res => {
        console.log(res.data.data, 'res.data.data')
        that.cepingren = res.data.data
      })
    },
    an() {
      loading = this.$loading({
        lock: true,
        text: "上传中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: 'jiaz'
      });
      let url = window.location.href
      let urlCode = url.substring(url.indexOf("=") + 1)
      console.log(urlCode,'this.urlCode')
      let that = this
      this.$axios({
        method: "GET",
        url: indexurl + "/index.php/api/index/getResult?key=" + urlCode,
        data: {}
      }).then(res => {
        let z = res.data.data.test_result.sort(function (a, b) {
          if (a.cp_classify_id > b.cp_classify_id) {
            return a.cp_classify_id - b.cp_classify_id
          } else if (a.cp_classify_id === b.cp_classify_id) {
            if (a.cp_titles_id > b.cp_titles_id) {
              return 1
            } else if (a.cp_titles_id === b.cp_titles_id) {
              return 0
            } else {
              return -1
            }
          } else {
            return a.cp_classify_id - b.cp_classify_id
          }
        })
        that.test_results = z
        console.log(that.test_results, 'that.test_results')
        let arr = []
        for (var i in this.test_results) {
          for (var j in this.test_results[i].question_data.select_effect_data) {
            arr.push(this.test_results[i].question_data.select_effect_data[j].select_score)
          }
        }
        that.zhongji = arr
        let rarrs = []
        let zarrs = []
        let larrs = []
        let farrs = []
        let garrs = []
        for (var a in this.test_results) {
          if (this.test_results[a].cp_titles_name == '人才') {
            rarrs.push(this.test_results[a].question_data.status)
          } else if (this.test_results[a].cp_titles_name == '制度') {
            zarrs.push(this.test_results[a].question_data.status)
          } else if (this.test_results[a].cp_titles_name == '流程') {
            larrs.push(this.test_results[a].question_data.status)
          } else if (this.test_results[a].cp_titles_name == '方法') {
            farrs.push(this.test_results[a].question_data.status)
          } else if (this.test_results[a].cp_titles_name == '工具') {
            garrs.push(this.test_results[a].question_data.status)
          }
        }
        let rencai = {}
        let zhidu = {}
        let liucheng = {}
        let fangfa = {}
        let gongju = {}
        rarrs.forEach(item => {
          rencai[item] = (rencai[item] + 1) || 1
        })
        zarrs.forEach(item => {
          zhidu[item] = (zhidu[item] + 1) || 1
        })
        larrs.forEach(item => {
          liucheng[item] = (liucheng[item] + 1) || 1
        })
        farrs.forEach(item => {
          fangfa[item] = (fangfa[item] + 1) || 1
        })
        garrs.forEach(item => {
          gongju[item] = (gongju[item] + 1) || 1
        })
        that.rencai = rencai
        that.zhidu = zhidu
        that.liucheng = liucheng
        that.fangfa = fangfa
        that.gongju = gongju
        console.log(that.rencai, 'that.rencai')
        console.log(that.zhidu, 'that.zhidu')
        console.log(that.liucheng, 'that.liucheng')
        console.log(that.fangfa, 'that.fangfa')
        console.log(that.gongju, 'that.gongju')
        this.tongji()
        this.ec()
        that.toGetPdf()
      })
    },
    group(newArr, arr, num) {
      if (arr.length > 0) {
        if (arr.length > num) { //arr 的长度大于 分组数
          newArr.push(arr.splice(0, num)) //分组
          this.group(newArr, arr, num) //递归
        } else {
          //如果长度不够分为一组，就直接把剩余的分为一组
          newArr.push(arr)
        }
      }
      return newArr //返回已分组的新数组
    },
    tongji() {
      let a = this.zhongji //原数组
      let b = [] //新书组容器
      let num = 5 //期望3个为一组
      let newArr = this.group(b, a, num)
      this.fenarr = newArr
      this.option.series[0].data = this.fenarr[0]
      this.option.series[1].data = this.fenarr[1]
      this.option.series[2].data = this.fenarr[2]
      this.option.series[3].data = this.fenarr[3]
      this.option.series[4].data = this.fenarr[4]
      this.option.series[5].data = this.fenarr[5]
      this.option.series[6].data = this.fenarr[6]
      this.option.series[7].data = this.fenarr[7]
      this.option.series[8].data = this.fenarr[8]
      this.option.series[9].data = this.fenarr[9]
      this.option.series[10].data = this.fenarr[10]
      this.option.series[11].data = this.fenarr[11]
      this.option.series[12].data = this.fenarr[12]
      this.option.series[13].data = this.fenarr[13]
      this.option.series[14].data = this.fenarr[14]
      this.option.series[15].data = this.fenarr[15]
      this.option.series[16].data = this.fenarr[16]
      this.option.series[17].data = this.fenarr[17]
      this.option.series[18].data = this.fenarr[18]
      this.option.series[19].data = this.fenarr[19]
      let xiaoji0 = this.option.series[0].data[0] + this.option.series[0].data[1] + this.option.series[0].data[2] + this.option.series[0].data[3] + this.option.series[0].data[4]
      let xiaojis0 = xiaoji0.toFixed(2) * 100
      this.zhanlie0 = xiaojis0 / 100
      let xiaoji1 = this.option.series[1].data[0] + this.option.series[1].data[1] + this.option.series[1].data[2] + this.option.series[1].data[3] + this.option.series[1].data[4]
      let xiaojis1 = xiaoji1.toFixed(2) * 100
      this.zhanlie1 = xiaojis1 / 100
      let xiaoji2 = this.option.series[2].data[0] + this.option.series[2].data[1] + this.option.series[2].data[2] + this.option.series[2].data[3] + this.option.series[2].data[4]
      let xiaojis2 = xiaoji2.toFixed(2) * 100
      this.zhanlie2 = xiaojis2 / 100
      let xiaoji3 = this.option.series[3].data[0] + this.option.series[3].data[1] + this.option.series[3].data[2] + this.option.series[3].data[3] + this.option.series[3].data[4]
      let xiaojis3 = xiaoji3.toFixed(2) * 100
      this.zhanlie3 = xiaojis3 / 100
      let xiaoji4 = this.option.series[4].data[0] + this.option.series[4].data[1] + this.option.series[4].data[2] + this.option.series[4].data[3] + this.option.series[4].data[4]
      let xiaojis4 = xiaoji4.toFixed(2) * 100
      this.zhanlie4 = xiaojis4 / 100
      let xiaoji5 = this.option.series[5].data[0] + this.option.series[5].data[1] + this.option.series[5].data[2] + this.option.series[5].data[3] + this.option.series[5].data[4]
      let xiaojis5 = xiaoji5.toFixed(2) * 100
      this.zhanlie5 = xiaojis5 / 100
      let xiaoji6 = this.option.series[6].data[0] + this.option.series[6].data[1] + this.option.series[6].data[2] + this.option.series[6].data[3] + this.option.series[6].data[4]
      let xiaojis6 = xiaoji6.toFixed(2) * 100
      this.zhanlie6 = xiaojis6 / 100
      let xiaoji7 = this.option.series[7].data[0] + this.option.series[7].data[1] + this.option.series[7].data[2] + this.option.series[7].data[3] + this.option.series[7].data[4]
      let xiaojis7 = xiaoji7.toFixed(2) * 100
      this.zhanlie7 = xiaojis7 / 100
      let xiaoji8 = this.option.series[8].data[0] + this.option.series[8].data[1] + this.option.series[8].data[2] + this.option.series[8].data[3] + this.option.series[8].data[4]
      let xiaojis8 = xiaoji8.toFixed(2) * 100
      this.zhanlie8 = xiaojis8 / 100
      let xiaoji9 = this.option.series[9].data[0] + this.option.series[9].data[1] + this.option.series[9].data[2] + this.option.series[9].data[3] + this.option.series[9].data[4]
      let xiaojis9 = xiaoji9.toFixed(2) * 100
      this.zhanlie9 = xiaojis9 / 100
      let xiaoji10 = this.option.series[10].data[0] + this.option.series[10].data[1] + this.option.series[10].data[2] + this.option.series[10].data[3] + this.option.series[10].data[4]
      let xiaojis10 = xiaoji10.toFixed(2) * 100
      this.zhanlie10 = xiaojis10 / 100
      let xiaoji11 = this.option.series[11].data[0] + this.option.series[11].data[1] + this.option.series[11].data[2] + this.option.series[11].data[3] + this.option.series[11].data[4]
      let xiaojis11 = xiaoji11.toFixed(2) * 100
      this.zhanlie11 = xiaojis11 / 100
      let xiaoji12 = this.option.series[12].data[0] + this.option.series[12].data[1] + this.option.series[12].data[2] + this.option.series[12].data[3] + this.option.series[12].data[4]
      let xiaojis12 = xiaoji12.toFixed(2) * 100
      this.zhanlie12 = xiaojis12 / 100
      let xiaoji13 = this.option.series[13].data[0] + this.option.series[13].data[1] + this.option.series[13].data[2] + this.option.series[13].data[3] + this.option.series[13].data[4]
      let xiaojis13 = xiaoji13.toFixed(2) * 100
      this.zhanlie13 = xiaojis13 / 100
      let xiaoji14 = this.option.series[14].data[0] + this.option.series[14].data[1] + this.option.series[14].data[2] + this.option.series[14].data[3] + this.option.series[14].data[4]
      let xiaojis14 = xiaoji14.toFixed(2) * 100
      this.zhanlie14 = xiaojis14 / 100
      let xiaoji15 = this.option.series[15].data[0] + this.option.series[15].data[1] + this.option.series[15].data[2] + this.option.series[15].data[3] + this.option.series[15].data[4]
      let xiaojis15 = xiaoji15.toFixed(2) * 100
      this.zhanlie15 = xiaojis15 / 100
      let xiaoji16 = this.option.series[16].data[0] + this.option.series[16].data[1] + this.option.series[16].data[2] + this.option.series[16].data[3] + this.option.series[16].data[4]
      let xiaojis16 = xiaoji16.toFixed(2) * 100
      this.zhanlie16 = xiaojis16 / 100
      let xiaoji17 = this.option.series[17].data[0] + this.option.series[17].data[1] + this.option.series[17].data[2] + this.option.series[17].data[3] + this.option.series[17].data[4]
      let xiaojis17 = xiaoji17.toFixed(2) * 100
      this.zhanlie17 = xiaojis17 / 100
      let xiaoji18 = this.option.series[18].data[0] + this.option.series[18].data[1] + this.option.series[18].data[2] + this.option.series[18].data[3] + this.option.series[18].data[4]
      let xiaojis18 = xiaoji18.toFixed(2) * 100
      this.zhanlie18 = xiaojis18 / 100
      let xiaoji19 = this.option.series[19].data[0] + this.option.series[19].data[1] + this.option.series[19].data[2] + this.option.series[19].data[3] + this.option.series[19].data[4]
      let xiaojis19 = xiaoji19.toFixed(2) * 100
      this.zhanlie19 = xiaojis19 / 100
      let aaa = this.zhanlie0 + this.zhanlie1 + this.zhanlie2 + this.zhanlie3 + this.zhanlie4 + this.zhanlie5 + this.zhanlie6 + this.zhanlie7 + this.zhanlie8 + this.zhanlie9 + this.zhanlie10 + this.zhanlie11 + this.zhanlie12 + this.zhanlie13 + this.zhanlie14 + this.zhanlie15 + this.zhanlie16 + this.zhanlie17 + this.zhanlie18 + this.zhanlie19
      let aaaa = aaa.toFixed(2) * 100
      this.aaaa = aaaa / 100

      let f = this.option.series
      let nummm = 0
      for (var i = 0; i < f.length; i++) {
        let ff = f[i].data[0] * 100
        nummm += Number(ff)
      }
      this.rencaifenshu = nummm / 100

      let nummmm = 0
      for (var i = 0; i < f.length; i++) {
        let fff = f[i].data[1] * 100
        nummmm += Number(fff)
      }
      this.zhidufenshu = nummmm / 100

      let nummmmm = 0
      for (var i = 0; i < f.length; i++) {
        let ffff = f[i].data[2] * 100
        nummmmm += Number(ffff)
      }
      this.liuchengfenshu = nummmmm / 100

      let nummmmmm = 0
      for (var i = 0; i < f.length; i++) {
        let fffff = f[i].data[3] * 100
        nummmmmm += Number(fffff)
      }
      this.fangfafenshu = nummmmmm / 100

      let nummmmmmm = 0
      for (var i = 0; i < f.length; i++) {
        let ffffff = f[i].data[3] * 100
        nummmmmmm += Number(ffffff)
      }
      this.gongjufenshu = nummmmmmm / 100

    },
    getNowDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      let time = `${year}年${month}月${day}`
      this.timeaa = time
    },
    ec() {
      let chartDom = document.getElementById('main');
      let myChart = echarts.init(chartDom);
      let option
      option = this.option
      option && myChart.setOption(option);
    },
    toGetPdf(val = true, download = false) {
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(0, 0);     //这行代码很重要，它让页面的滚动条跳到了最上方如果点击打印按钮的时候,滚动条没有在最上方,打印内容会是不完整的,体验也会差
          let title = "个人报告"
          this.getPdf(title, download = false) //download：false为不下载，这里调用了刚刚引用的全局函数，.then得到的值是base64位的pdf文件
            .then((res) => {
              if (val) {
                this.UploadPdf(res);

              } else {
              }
            });
        }, 8000);
      });
    },
    UploadPdf(res) {
      let that = this;
      let pdfBase64Str = res;
      let title = "个人报告"
      let myfile = this.dataURLtoFile(pdfBase64Str, title + ".pdf");//调用一下下面的转文件流函数
      let formdata = new FormData();
      formdata.append("file", myfile); // 文件对象
      console.log(myfile, 'myfile')
      this.$axios.post(indexurl + '/index.php/api/common/upload', formdata)
        .then((res) => {
          console.log(res.data.data, '3')
          this.dow = res.data.data.fullurl
          // this.dow = res.data.data.url
          console.log(this.dow, '4')
          that.upurl(res.data.data.url)
          if (res.data.data.fullurl) {
            loading.close()
            this.$message({
              message: `提交成功，需查看报告，请联系管理员。`,
              type: 'success',
              duration: 0,
              showClose: true,
            });
            that.opst = true
          } else {
            this.$message({
              message: `数据提交失败`,
              type: 'error',
              duration: 0,
              showClose: true
            });
          }
        })
    },
    upurl(url) {
      let that = this
      this.$axios({
        method: "POST",
        url: indexurl + '/index.php/api/index/updateResult',
        data: {
          key: that.urlCode,
          file_url: url
        }
      }).then((res) => {
      })
    },
    baog() {
      let that = this
      this.$axios({
        method: "GET",
        url: indexurl + '/index.php/api/index/getConfig?key=jielun',
        data: {}
      }).then((res) => {
        console.log(res)
        that.baogs = res.data.data
        console.log(that.baogs)
      })
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    opstion() {
      this.opst = false
    },
    downloadFile(url = this.dow) {
      loading = this.$loading({
        lock: true,
        text: "下载中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: 'jiaz'
      });
      this.$message.close()
      //进度条恢复为 0
      this.percentage = 0;
      //发起请求
      this.$axios({
        url: url,
        method: "get",
        responseType: "blob",
        params: {},
      }).then(res => {
        loading.close()
        console.log(res, 'progressEvent')
        if (res.status != 200) {
          this.$message.error("文件下载失败，请稍后重试！");
          return false;
        }
        //blob返回的是一个 base64 格式的文件流
        let blob = new Blob([res.data], {
          //编译文件为xlsx类型。 具体可查看 blob 方法定义的类型
          type: "application/pdf"
        })
        //编译文件
        if (window.navigator && window.navigator.meSaveOrOpenBlob) {
          window.navigator.meSaveOrOpenBlob(blob, "诊断报告.pdf");
        } else {
          // 非ie的下载
          const link = document.createElement('a');
          const body = document.querySelector('body');
          link.href = window.URL.createObjectURL(blob);
          link.download = '诊断报告' + new Date().getTime(); // 下载的文件名
          // fix Firefox
          link.style.display = 'none';
          body.appendChild(link);
          link.click();
          body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }
        //编译文件完成后，进度条展示为100%100
        this.percentage = 100;
        this.progressShow = false; // 关闭进度条显示层

      })
    }
  }
}
</script>
<style scoped>
#pdfDom {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.word {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.home {
  height: 722mm;
  width: calc(1920px - 240px);
  padding: 0 120px;
  background: url("../../../static/image/pobg1.png") no-repeat;
  background-position: center bottom;
  background-size: 100% 100%;
  position: relative;
}

.word-name {
  transform: translateX(-130px);
  font-size: 80px;
  font-weight: bold;
  margin-bottom: 900px;
  text-align: center;
  margin-top: 330px;
  color: #ee1d23;
}

.word-des {
  font-size: 60px;
  font-weight: bold;
  margin-bottom: 40px;
  text-align: center;
  margin: 80px 0 300px 0;
}

.com-x {
  font-size: 60px;
  line-height: 95px;
  padding-left: 120px;
}

.com-span1 {


  display: inline-block;

  padding: 0 10px;
}

.com-span2 {


  display: inline-block;

  padding: 0 10px;
}

.time {
  font-size: 60px;
  margin-top: 20px;
  padding-left: 120px;
}

.home .preface-footer {
  font-size: 36px;
  color: #000;
  text-align: center;
  position: absolute;
  bottom: 120px;
  width: 1680px;
}

.preface {
  height: 689.5mm;
  width: calc(1920px - 240px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120px 120px 0 120px;
  background: linear-gradient(rgb(255 255 255 / 95%), rgb(255 255 255 / 95%)), url("../../../static/image/po-bg.png") no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  position: relative;

}

.predace-text {
  display: flex;
  font-size: 35px;
  color: #808080;
}

.pre-div {
  text-align: center;
  margin-bottom: 60px
}

h1 {
  font-size: 60px;
  font-weight: bold;
  margin-bottom: 40px;
  text-align: center;
}

p {
  font-size: 36px;
  text-indent: 2em;
  line-height: 40px;
}

.preface .preface-footer {
  font-size: 36px;
  color: #808080;
  position: absolute;
  bottom: 120px;
}

.word-3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120px 120px 0 120px;
  width: calc(1920px - 240px);
  height: 689.5mm;
  background: linear-gradient(rgb(255 255 255 / 95%), rgb(255 255 255 / 95%)), url("../../../static/image/po-bg.png") no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  position: relative;

}

.word-3-title {
  width: 100%;
  font-size: 36px;
}

.word-3-title-name {
  text-align: center;
  margin-bottom: 30px
}

.word-3-des {
  display: grid;
  grid-template-columns: 1fr 5fr 1fr;
  align-items: center;
  justify-items: center;
  border: 1px solid #000;
  height: 180px;
}

.word-3-l {
  text-align: center;
  height: 100%;
  line-height: 180px;
  border-right: 1px solid #000;
  width: 100%;
}

.text-r {
  margin-left: 50px;
}

.dow {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%)

}

.dow-btn {
  padding: 20px 50px;
  font-size: 18px;
  color: white;
  background: #67c23a;
  border-radius: 10px;
  cursor: pointer;
}

.dow-btn {
  margin-top: 20px;
}


.postion {
  display: none;
}

.pobg {
  background: linear-gradient(rgb(255 255 255 / 95%), rgb(255 255 255 / 95%)), url("../../../static/image/po-bg.png") no-repeat;
  background-position: center center;
  background-size: 100% 100%;
}

.pobgs {
  background: linear-gradient(rgb(255 255 255 / 95%), rgb(255 255 255 / 95%)), url("../../../static/image/po-bg.png");
  background-position: center center;
  background-repeat: repeat-y;
  background-size: 100% 100%;
}
.dows{
  display: none;
}
.bgssss{
  display: none;
}
@media (max-width: 768px) {
  /deep/ .jiaz {
    width: 100vw !important;
    height: 100vh !important;
  }
  .bgssss{
    display: flex;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.34);
    position: absolute;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
  }
  .te{
    color: #fff;
  }
  .dows{
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%)
  }
  /deep/.el-dialog__wrapper{
    display: none;
  }
  .el-loading-mask.is-fullscreen {
    width: 100vw !important;
    height: 100vh !important;
    display: none !important;
  }

  .postion {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    width: 100vw;
    height: 100vh;
  }

  .po-title {
    width: clac(100% -40px);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 36px;
    text-align: center;
    padding: 0 20px;
  }

  .postion {
    display: block;
  }

  .dow {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Cha/index.vue